import { createServerFn } from "@tanstack/react-start";

/**
 * Zwraca identyfikator pomiaru GA4 zapisany w sekretach projektu.
 * Identyfikator pomiaru (G-...) to informacja publiczna (widoczna w kodzie
 * każdej strony mierzonej GA), więc może trafić do przeglądarki.
 */
export const getGaMeasurementId = createServerFn({ method: "GET" }).handler(
  async () => {
    return { measurementId: process.env["GOOGLE_ANALYTICS_MEASUREMENT_ID"] ?? null };
  },
);
